export enum LogLevel {
  TRACE = 0,
  DEBUG = 1,
  INFORMATION = 2,
  WARNING = 3,
  ERROR = 4,
  CRITICAL = 5,
  NONE = 6,
}

export const LogLevelMap = new Map<LogLevel, string>([
  [LogLevel.TRACE, "[TRACE]"],
  [LogLevel.DEBUG, "[DEBUG]"],
  [LogLevel.INFORMATION, "[INF]"],
  [LogLevel.WARNING, "[WARN]"],
  [LogLevel.ERROR, "[ERR]"],
  [LogLevel.CRITICAL, "[CRIT]"],
  [LogLevel.NONE, "[NONE]"],
]);
